import dayjs, { Dayjs } from "dayjs";

export const slashedYMD = (d: Date): string =>
  dayjs(d).locale("ja").format("YYYY/MM/DD");

export const slashedYMDAndDayOfWeek = (d: Date): string =>
  dayjs(d).locale("ja").format("YYYY/MM/DD (dd)");

export const dd = (d: Date | string): string =>
  dayjs(d).locale("ja").format("dd");
export const slashedMMDD = (d: Date | string): string =>
  dayjs(d).locale("ja").format("MM/DD");

export const slashedYMDFromString = (s: string): string =>
  dayjs(s).locale("ja").format("YYYY/MM/DD");

export const hyphenedYMDFromString = (s: string): string =>
  dayjs(s).locale("ja").format("YYYY-MM-DD");

export const hyphenedYM = (d: Date): string =>
  dayjs(d).locale("ja").format("YYYY-MM");

// 何れOrganization毎とかなると別で殺る必要があるけど一旦統一して土日を除く5日という仕様なのでここに置く
export const cutOffDate = (currentMonth: Dayjs): Dayjs => {
  const startOfMonth = currentMonth.startOf("month").endOf("day");
  let adjustedDays = 6;
  switch (startOfMonth.day()) {
    case 0:
      adjustedDays = 5;
      break;
    case 1:
      adjustedDays = 4;
      break;
    default:
      break;
  }
  return startOfMonth.add(adjustedDays, "days");
};

export const isOverCutOffDate = (checkMonth: Dayjs): boolean => {
  const checkCutOffDate = cutOffDate(checkMonth.add(1, "month"));
  return checkCutOffDate < dayjs();
};

export const getMonthString = (offsetMonth?: number): string => {
  const offset = offsetMonth || 0;
  const monthInParams = new URL(window.location.href).searchParams.get("month");
  const date = monthInParams
    ? new Date(
        parseInt(monthInParams.split("-")[0], 10),
        parseInt(monthInParams.split("-")[1], 10) + offset - 1
      )
    : new Date(new Date().getFullYear(), new Date().getMonth() + offset);
  return hyphenedYM(date);
};
